import css from './MeownessRays.css';

export class MeownessRays {
    activate() {
        this._container = document.createElement('div');
        this._container.className = css.container;
        document.body.appendChild(this._container);
    }

    engageMediumPower() {
        this._container.className = Array.from(this._container.classList).concat(css["container--medium"]).join(' ');
    }

    engageHeavyPower() {
        this._container.className = Array.from(this._container.classList).concat(css["container--heavy"]).join(' ');
    }

    deactivate() {
        document.body.removeChild(this._container);
    }
}
